//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import ContractListView from '@/views/HumanResource/HrContract/HrContractList'
import ContractCreateView from '@/views/HumanResource/HrContract/HrContractCreate'
import ContractUpdateView from '@/views/HumanResource/HrContract/HrContractUpdate'

//
export default {
    path: 'contract',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'contract-list',
            component: ContractListView,
        },
        {
            path: 'create',
            name: 'contract-create',
            component: ContractCreateView,
            meta: {
                title: 'Crear contrato',
            },
        },
        {
            path: ':id',
            name: 'contract-update',
            component: ContractUpdateView,
            meta: {
                title: 'Detalles del contrato',
            },
        },
    ],
    meta: {
        title: 'Contratos',
    },
}
